
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./calendar_mgmt_extension": () => {
return Promise.all([__webpack_require__.e("326"), __webpack_require__.e("90"), __webpack_require__.e("231"), __webpack_require__.e("417"), __webpack_require__.e("880")]).then(() => (() => (__webpack_require__(3978))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };